"use client";
import ImageWithListCard from "@/revamp/molecules/ImageWithListCard";
import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

export default function HolisticCareerServicesSection({ data, wrapperClass="" }) {
  return (
    <div className="Carousel">
      <Swiper
        wrapperClass={wrapperClass}
        autoplay={{
          delay: 6000,
        }}
        modules={[Pagination, Autoplay]}
        spaceBetween={20}
        slidesPerView={"auto"}
        pagination={{ clickable: true }}
        className="Carousel__blueBullet Carousel__hAuto"
        breakpoints={{
          0: {
            slidesPerView: 1
          },
          481: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          769: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1025: {
            slidesPerView: 4,
            spaceBetween: 30
          }
        }}
      >
        {data.map((item, index) => (
          <SwiperSlide key={index}>
            <ImageWithListCard {...item} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
